import { render } from "./providerLayout.vue?vue&type=template&id=0af66904&ts=true"
import script from "./providerLayout.vue?vue&type=script&lang=ts"
export * from "./providerLayout.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__